var render = function render(){var _vm=this,_c=_vm._self._c;return _c('com-page',[_c('com-community-search',{on:{"add":_vm.handleCreated,"search":_vm.handleSearch}}),_c('com-card',[_c('com-community-list',{ref:"communityListRef"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }